import "./App.css";
// import "./App.scss";

import { About, Achievements, Header, Skills, Projects, Experience } from "./Container";
import { Navbar } from "./Components";
import { Analytics } from "@vercel/analytics/react";
// import bg from "./assets/snow.svg";
import SocialMedia from "./Components/SocialMedia";
function App() {
	return (
		<div className="App transition duration-300 ease-in-out scroll-smooth">
			<Analytics />

			<Navbar />

			<Header />
			{/* <div className="spline">
                <SplineElement />
          </div> */}
			<SocialMedia isContact={false} />
			<Skills />
			<Experience />
			<Projects />
			<Achievements />
			<About />
			{/* <Footer /> */}
		</div>
	);
}

export default App;
